import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import Strapi, {
    EndpointQueryParameters,
    StrapiCreate,
    StrapiSingle,
    StrapiUpdate,
} from '../../types/strapi/strapi'
import ReceiptPosition from '../../types/api/receipt-position'
import getQuery from '../../helpers/api/get-query'

export const receiptPositionsApi = createApi({
    reducerPath: 'receiptPositionsApi',
    baseQuery: getCustomFetchBase({ baseUrl: process.env.REACT_APP_API_URL }),
    tagTypes: ['ReceiptPositions'],
    endpoints: builder => ({
        getReceiptPositions: builder.query<Strapi<ReceiptPosition>, EndpointQueryParameters | void>(
            { query: getQuery('/receipt-positions'), providesTags: ['ReceiptPositions'] }
        ),
        getReceiptPositionByDocId: builder.query<
            StrapiSingle<ReceiptPosition>,
            [string, EndpointQueryParameters | void]
        >({
            query: ([docId, params]) => getQuery(`/receipt-positions/${docId}`)(params),
            providesTags: ['ReceiptPositions'],
        }),
        createReceiptPosition: builder.mutation<
            StrapiSingle<ReceiptPosition>,
            StrapiCreate<ReceiptPosition>
        >({
            query: body => ({
                url: '/receipt-positions',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['ReceiptPositions'],
        }),
        updateReceiptPosition: builder.mutation<
            StrapiSingle<ReceiptPosition>,
            StrapiUpdate<ReceiptPosition>
        >({
            query: ({ docId, body }) => ({
                url: `/receipt-positions/${docId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['ReceiptPositions'],
        }),
    }),
})

export const {
    useCreateReceiptPositionMutation,
    useGetReceiptPositionsQuery,
    useLazyGetReceiptPositionByDocIdQuery,
    useUpdateReceiptPositionMutation,
} = receiptPositionsApi
